import { render, staticRenderFns } from "./RestaurantModest.vue?vue&type=template&id=f92a0fae"
import script from "./RestaurantModest.vue?vue&type=script&lang=js"
export * from "./RestaurantModest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports